module.exports = __webpack_public_path__ + "static/media/IMG_0741.c66165d7.jpg";